/**
 * Theme Flows — entry/exit timelines diffed from registry history snapshots.
 */
import React from "react";
import { ArrowRightLeft, Sparkles } from "lucide-react";

export const FlowTimeline = ({ flows, testid }) => {
  if (!flows?.length) return null;
  return (
    <div className="mt-3 space-y-1.5" data-testid={testid}>
      <p className="text-[10px] font-mono text-muted-foreground uppercase tracking-wide">
        Membership flows
      </p>
      {flows.map((f) => (
        <div key={f.run} className="flex items-center gap-2 flex-wrap text-[11px] font-mono">
          <span className="text-muted-foreground w-20 shrink-0">{f.run}</span>
          {f.initial ? (
            <>
              <span className="px-1.5 py-0.5 rounded border border-sky-500/40 text-sky-300 text-[10px]">
                formed
              </span>
              <span className="text-muted-foreground">{f.entered.join(", ")}</span>
            </>
          ) : (
            <>
              {f.entered.map((s) => (
                <span key={s} className="px-1.5 py-0.5 rounded bg-emerald-500/10 border border-emerald-500/40 text-emerald-300">
                  +{s}
                </span>
              ))}
              {f.exited.map((s) => (
                <span key={s} className="px-1.5 py-0.5 rounded bg-red-500/10 border border-red-500/40 text-red-300">
                  −{s}
                </span>
              ))}
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export const RecentMovementsStrip = ({ recent, latestRun }) => {
  if (!recent?.length) return null;
  return (
    <div className="rounded-md border border-border bg-card/60 px-4 py-3"
         data-testid="recent-movements-strip">
      <div className="flex items-center gap-2 mb-2">
        <ArrowRightLeft className="w-3.5 h-3.5 text-amber-400" />
        <span className="text-xs font-semibold">Recent movements</span>
        <span className="text-[10px] font-mono text-muted-foreground">
          last runs → {latestRun}
        </span>
      </div>
      <div className="flex gap-x-5 gap-y-1.5 flex-wrap">
        {recent.slice(0, 14).map((r, i) => (
          <div key={`${r.theme_id}-${r.run}-${i}`}
               className="flex items-center gap-1.5 text-[11px] font-mono"
               data-testid={`movement-${r.theme_id}`}>
            {r.new_theme && <Sparkles className="w-3 h-3 text-sky-400" />}
            <span className="text-foreground/90">{r.name || "Unnamed"}</span>
            {r.new_theme ? (
              <span className="text-sky-300">new · {r.entered.join(" ")}</span>
            ) : (
              <>
                {r.entered.length > 0 && (
                  <span className="text-emerald-400">{r.entered.map((s) => `+${s}`).join(" ")}</span>
                )}
                {r.exited.length > 0 && (
                  <span className="text-red-400">{r.exited.map((s) => `−${s}`).join(" ")}</span>
                )}
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
